import React from 'react';
export function Problems() {
  const problems = [{
    icon: '😶',
    title: 'No sabés por dónde empezar',
    desc: 'Querés arrancar pero no tenés claro qué vender, cuánto invertir ni cómo conseguir mercadería sin que te estafen.'
  }, {
    icon: '📉',
    title: 'Vendés a pérdida sin saberlo',
    desc: 'Ponés el precio a ojo, sin fórmula. A veces ganás, a veces regalás tu trabajo. No hay forma de saber cuánto ganaste en el mes.'
  }, {
    icon: '🔍',
    title: 'Buscás info suelta en YouTube',
    desc: 'Videos de otros países, sin contexto local, sin proveedores argentinos, sin ferias, sin Mercado Pago. Nada del todo útil.'
  }, {
    icon: '🤷',
    title: 'No sabés si el proveedor es confiable',
    desc: 'El Once parece un laberinto. No sabés a quién comprarle, cómo negociar el precio ni qué señales te indican que te están clavando.'
  }, {
    icon: '📲',
    title: 'Perdés ventas por no saber qué decir',
    desc: 'Te preguntan "¿cuántos quilates tiene?" o "¿es bañado o laminado?" y no sabés cómo responder con autoridad.'
  }, {
    icon: '🗓️',
    title: 'Fin de mes sin resultados concretos',
    desc: 'Vendiste algo, compraste algo, pero no sabés si progresaste. No hay registro, no hay control, no hay negocio real todavía.'
  }, {
    icon: '🌀',
    title: 'No sabés dónde vender',
    desc: '¿Redes sociales? ¿Ferias? ¿WhatsApp? ¿Mercado Libre? Sin un sistema que lo ordene, terminás en todos lados y en ninguno.'
  }, {
    icon: '😓',
    title: 'Miedo a invertir y perder plata',
    desc: 'Sabés que el negocio existe. El miedo no es a las joyas — es a no saber lo suficiente para que funcione.'
  }];
  return <section className="py-12 sm:py-20" data-id="element-240">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-241">
        <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-242">
          ¿Te pasa esto?
        </div>
        <h2 className="mb-4 font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-243">
          Si vendés o querés vender joyas en Argentina, esto te suena familiar
        </h2>
        <p className="mb-8 sm:mb-12 max-w-[560px] text-[15px] text-text" data-id="element-244">
          El mercado de joyas y oro en Argentina mueve millones. El problema no
          es la demanda — es no tener un sistema.
        </p>

        <div className="flex flex-col gap-3" data-id="element-245">
          {problems.map((prob, i) => <div key={i} className="flex items-start gap-4 rounded-xl border border-[#1a1200] bg-[#0d0900] p-4 transition-colors duration-300 hover:border-gold/40 sm:items-center sm:p-5" data-id="element-246">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-gold/20 bg-gold/10 text-[20px]" data-id="element-247">
                {prob.icon}
              </div>
              <div className="flex-1" data-id="element-248">
                <div className="mb-1 text-[14px] font-semibold text-white" data-id="element-249">
                  {prob.title}
                </div>
                <div className="text-[12px] leading-[1.6] text-muted" data-id="element-250">
                  {prob.desc}
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10 border-t border-border pt-8 text-center text-[18px] font-semibold text-white" data-id="element-251">
          ¿Cuántos meses más vas a esperar para arrancar
          <span className="text-gold" data-id="element-252"> con un sistema que funcione</span>?
        </div>
      </div>
    </section>;
}